import { useState } from 'react';
import { PmoFlowView } from '../pmo-flow/index.js';
import { PmoDeliveryView } from './PmoDeliveryView.js';
import { PmoViewSwitch, type PmoView as PmoViewKey } from './PmoViewSwitch.js';

/**
 * PMO KPI 画面のシェル。プロセス / デリバリーの 2 view を pill スイッチで切替える。
 *
 * 各 view はそれぞれ自前の見出しと期間セレクトを持つので、ここは切替 state と
 * スイッチの置き場所だけを持ち、中身には関与しない。既定はこれまで単独で
 * 表示していたプロセス view にして、既存利用者の見え方を変えない。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business PMO KPI画面のシェル。プロセス（充足率・フェーズリードタイム）とデリバリー（遅延・リリース数）の2 viewをpillスイッチで切替える
 * @graph-connects PmoViewSwitch [calls] view切替スイッチ描画
 * @graph-connects PmoFlowView [calls] プロセスview表示
 * @graph-connects PmoDeliveryView [calls] デリバリーview表示
 */
export function PmoView() {
  const [view, setView] = useState<PmoViewKey>('process');

  return (
    <div className="space-y-4">
      <PmoViewSwitch view={view} onChange={setView} />
      {view === 'process' ? <PmoFlowView /> : <PmoDeliveryView />}
    </div>
  );
}
